import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TwitchChatComponent } from './twitch-chat.component';
import { VbLxpPanelComponent } from '@vbrick/vb-lxp-lib';

@NgModule({
	declarations: [TwitchChatComponent],
	imports: [CommonModule, VbLxpPanelComponent],
	exports: [TwitchChatComponent]
})
export class TwitchChatModule {}
